export const loanAccountL3 = [
    {
        "cif_key":6441273160,
        "id_number":95613230,
        "product_name":"Import LC_Product added for UAT",
        "credit_limit":365000000.0,
        "outstanding":0.0,
        "loan_type":"Non Cash",
        "maturity_date":"2008-11-24",
        "overdue_payment":0.0,
        "account_status":"PARTIALLY ADVANCED",
        "repayment_schedule":20,
        "due_date":"20 of every month",
        "company_name":"PERTAMINA (PERSERO)",
        "group_company":"PERTAMINA GROUP",
        "credit_utilization_percent":0.0
    },
    {
        "cif_key":6441273160,
        "id_number":12013250,
        "product_name":"Import LC_Product added for UAT",
        "credit_limit":0.0,
        "outstanding":0.0,
        "loan_type":"Non Cash",
        "maturity_date":"2010-03-06",
        "overdue_payment":0.0,
        "account_status":"PARTIALLY ADVANCED",
        "repayment_schedule":26,
        "due_date":"26 of every month",
        "company_name":"PERTAMINA (PERSERO)",
        "group_company":"PERTAMINA GROUP",
        "credit_utilization_percent":null
    },
    {
        "cif_key":6441273160,
        "id_number":12012881,
        "product_name":"Import LC_Product added for UAT",
        "credit_limit":0.0,
        "outstanding":0.0,
        "loan_type":"Non Cash",
        "maturity_date":"2010-03-06",
        "overdue_payment":0.0,
        "account_status":"PARTIALLY ADVANCED",
        "repayment_schedule":26,
        "due_date":"26 of every month",
        "company_name":"PERTAMINA (PERSERO)",
        "group_company":"PERTAMINA GROUP",
        "credit_utilization_percent":null
    },
    {
        "cif_key":6441273160,
        "id_number":228434824,
        "product_name":"Productive Credit - Trust Receipt USD",
        "credit_limit":0.0,
        "outstanding":0.0,
        "loan_type":"Cash",
        "maturity_date":"2014-04-14",
        "overdue_payment":0.0,
        "account_status":"ACCEPTED",
        "repayment_schedule":20,
        "due_date":"20 of every month",
        "company_name":"PERTAMINA (PERSERO)",
        "group_company":"PERTAMINA GROUP",
        "credit_utilization_percent":null
    },
    {
        "cif_key":6441273160,
        "id_number":91559053,
        "product_name":"Import LC_Product added for UAT",
        "credit_limit":15820019.8000000007,
        "outstanding":0.0,
        "loan_type":"Non Cash",
        "maturity_date":"2008-09-30",
        "overdue_payment":0.0,
        "account_status":"PARTIALLY ADVANCED",
        "repayment_schedule":23,
        "due_date":"23 of every month",
        "company_name":"PERTAMINA (PERSERO)",
        "group_company":"PERTAMINA GROUP",
        "credit_utilization_percent":0.0
    },
    {
        "cif_key":6441273160,
        "id_number":555914530,
        "product_name":"Productive Credit - Trust Receipt USD",
        "credit_limit":0.0,
        "outstanding":0.0,
        "loan_type":"Cash",
        "maturity_date":"2019-05-21",
        "overdue_payment":0.0,
        "account_status":"ACCEPTED",
        "repayment_schedule":20,
        "due_date":"20 of every month",
        "company_name":"PERTAMINA (PERSERO)",
        "group_company":"PERTAMINA GROUP",
        "credit_utilization_percent":null
    },
    {
        "cif_key":6441273160,
        "id_number":147351670,
        "product_name":"Productive Credit - KMK Bank EFEKTIF USD",
        "credit_limit":0.0,
        "outstanding":0.0,
        "loan_type":"Cash",
        "maturity_date":"2011-03-27",
        "overdue_payment":0.0,
        "account_status":"ACCEPTED",
        "repayment_schedule":20,
        "due_date":"20 of every month",
        "company_name":"PERTAMINA (PERSERO)",
        "group_company":"PERTAMINA GROUP",
        "credit_utilization_percent":null
    },
    {
        "cif_key":6441273160,
        "id_number":76023838,
        "product_name":"Import LC_Product added for UAT",
        "credit_limit":64979963.0399999991,
        "outstanding":0.0,
        "loan_type":"Non Cash",
        "maturity_date":"2006-10-17",
        "overdue_payment":0.0,
        "account_status":"PENDING DISCHARGED",
        "repayment_schedule":26,
        "due_date":"26 of every month",
        "company_name":"PERTAMINA (PERSERO)",
        "group_company":"PERTAMINA GROUP",
        "credit_utilization_percent":0.0
    },
    {
        "cif_key":6441273160,
        "id_number":78162617,
        "product_name":"Productive Credit - KMK Bank EFEKTIF USD",
        "credit_limit":0.0,
        "outstanding":0.0,
        "loan_type":"Cash",
        "maturity_date":"2006-12-06",
        "overdue_payment":0.0,
        "account_status":"ACCEPTED",
        "repayment_schedule":26,
        "due_date":"26 of every month",
        "company_name":"PERTAMINA (PERSERO)",
        "group_company":"PERTAMINA GROUP",
        "credit_utilization_percent":null
    },
    {
        "cif_key":6441273160,
        "id_number":234933278,
        "product_name":"Productive Credit - Trust Receipt USD",
        "credit_limit":0.0,
        "outstanding":0.0,
        "loan_type":"Cash",
        "maturity_date":"2014-06-17",
        "overdue_payment":0.0,
        "account_status":"ACCEPTED",
        "repayment_schedule":20,
        "due_date":"20 of every month",
        "company_name":"PERTAMINA (PERSERO)",
        "group_company":"PERTAMINA GROUP",
        "credit_utilization_percent":null
    },
    {
        "cif_key":6441273160,
        "id_number":121574760,
        "product_name":"Import LC_Product added for UAT",
        "credit_limit":5110000000.0,
        "outstanding":0.0,
        "loan_type":"Non Cash",
        "maturity_date":"2011-07-10",
        "overdue_payment":0.0,
        "account_status":"PARTIALLY ADVANCED",
        "repayment_schedule":23,
        "due_date":"23 of every month",
        "company_name":"PERTAMINA (PERSERO)",
        "group_company":"PERTAMINA GROUP",
        "credit_utilization_percent":0.0
    },
    {
        "cif_key":6441273160,
        "id_number":90272866,
        "product_name":"Productive Credit - Term Loan Bank Efektif USD",
        "credit_limit":0.0,
        "outstanding":0.0,
        "loan_type":"Cash",
        "maturity_date":"2012-08-05",
        "overdue_payment":0.0,
        "account_status":"ACCEPTED",
        "repayment_schedule":20,
        "due_date":"20 of every month",
        "company_name":"PERTAMINA (PERSERO)",
        "group_company":"PERTAMINA GROUP",
        "credit_utilization_percent":null
    },
    {
        "cif_key":6441273160,
        "id_number":12013258,
        "product_name":"Import LC_Product added for UAT",
        "credit_limit":0.0,
        "outstanding":0.0,
        "loan_type":"Non Cash",
        "maturity_date":"2010-03-06",
        "overdue_payment":0.0,
        "account_status":"PARTIALLY ADVANCED",
        "repayment_schedule":26,
        "due_date":"26 of every month",
        "company_name":"PERTAMINA (PERSERO)",
        "group_company":"PERTAMINA GROUP",
        "credit_utilization_percent":null
    },
    {
        "cif_key":6441273160,
        "id_number":180585942,
        "product_name":"Productive Credit - KMK Bank EFEKTIF IDR",
        "credit_limit":0.0,
        "outstanding":0.0,
        "loan_type":"Cash",
        "maturity_date":"2012-08-30",
        "overdue_payment":0.0,
        "account_status":"ACCEPTED",
        "repayment_schedule":20,
        "due_date":"20 of every month",
        "company_name":"PERTAMINA (PERSERO)",
        "group_company":"PERTAMINA GROUP",
        "credit_utilization_percent":null
    },
    {
        "cif_key":6441273160,
        "id_number":202403863,
        "product_name":"Productive Credit - KMK Bank EFEKTIF IDR",
        "credit_limit":0.0,
        "outstanding":0.0,
        "loan_type":"Cash",
        "maturity_date":"2013-03-13",
        "overdue_payment":0.0,
        "account_status":"ACCEPTED",
        "repayment_schedule":20,
        "due_date":"20 of every month",
        "company_name":"PERTAMINA (PERSERO)",
        "group_company":"PERTAMINA GROUP",
        "credit_utilization_percent":null
    },
    {
        "cif_key":6441273160,
        "id_number":181826248,
        "product_name":"Import LC_Product added for UAT",
        "credit_limit":3545011.2102000001,
        "outstanding":3545011.2102000001,
        "loan_type":"Non Cash",
        "maturity_date":"2015-06-16",
        "overdue_payment":0.0,
        "account_status":"PARTIALLY ADVANCED",
        "repayment_schedule":23,
        "due_date":"23 of every month",
        "company_name":"PERTAMINA (PERSERO)",
        "group_company":"PERTAMINA GROUP",
        "credit_utilization_percent":100.0
    },
    {
        "cif_key":6441273160,
        "id_number":12012889,
        "product_name":"Import LC_Product added for UAT",
        "credit_limit":0.0,
        "outstanding":0.0,
        "loan_type":"Non Cash",
        "maturity_date":"2010-03-06",
        "overdue_payment":0.0,
        "account_status":"PARTIALLY ADVANCED",
        "repayment_schedule":26,
        "due_date":"26 of every month",
        "company_name":"PERTAMINA (PERSERO)",
        "group_company":"PERTAMINA GROUP",
        "credit_utilization_percent":null
    },
    {
        "cif_key":6441273160,
        "id_number":260423978,
        "product_name":"Import LC_Product added for UAT",
        "credit_limit":194180.0,
        "outstanding":0.0,
        "loan_type":"Non Cash",
        "maturity_date":"2026-02-21",
        "overdue_payment":0.0,
        "account_status":"PARTIALLY ADVANCED",
        "repayment_schedule":20,
        "due_date":"20 of every month",
        "company_name":"PERTAMINA (PERSERO)",
        "group_company":"PERTAMINA GROUP",
        "credit_utilization_percent":0.0
    },
    {
        "cif_key":6441273160,
        "id_number":319208163,
        "product_name":"Import LC_Product added for UAT",
        "credit_limit":94099991832.0,
        "outstanding":0.0,
        "loan_type":"Non Cash",
        "maturity_date":"2027-07-13",
        "overdue_payment":0.0,
        "account_status":"PARTIALLY ADVANCED",
        "repayment_schedule":20,
        "due_date":"20 of every month",
        "company_name":"PERTAMINA (PERSERO)",
        "group_company":"PERTAMINA GROUP",
        "credit_utilization_percent":0.0
    },
    {
        "cif_key":6441273160,
        "id_number":266375840,
        "product_name":"Import LC_Product added for UAT",
        "credit_limit":14600000.0,
        "outstanding":0.0,
        "loan_type":"Non Cash",
        "maturity_date":"2026-04-08",
        "overdue_payment":0.0,
        "account_status":"PARTIALLY ADVANCED",
        "repayment_schedule":20,
        "due_date":"20 of every month",
        "company_name":"PERTAMINA (PERSERO)",
        "group_company":"PERTAMINA GROUP",
        "credit_utilization_percent":0.0
    },
    {
        "cif_key":6441273160,
        "id_number":537043950,
        "product_name":"Import LC_Product added for UAT",
        "credit_limit":0.0,
        "outstanding":0.0,
        "loan_type":"Non Cash",
        "maturity_date":"2019-04-30",
        "overdue_payment":0.0,
        "account_status":"ACCEPTED",
        "repayment_schedule":20,
        "due_date":"20 of every month",
        "company_name":"PERTAMINA (PERSERO)",
        "group_company":"PERTAMINA GROUP",
        "credit_utilization_percent":null
    },
    {
        "cif_key":6434415954,
        "id_number":311075458,
        "product_name":"Import LC_Product added for UAT",
        "credit_limit":65700000000.0,
        "outstanding":0.0,
        "loan_type":"Non Cash",
        "maturity_date":"2025-05-06",
        "overdue_payment":0.0,
        "account_status":"PARTIALLY ADVANCED",
        "repayment_schedule":20,
        "due_date":"20 of every month",
        "company_name":"UNITED TRACTORS",
        "group_company":"ASTRA - UNITED TRACTORS",
        "credit_utilization_percent":0.0
    },
    {
        "cif_key":6434415954,
        "id_number":151004046,
        "product_name":"Import LC_Product added for UAT",
        "credit_limit":8760000.0,
        "outstanding":0.0,
        "loan_type":"Non Cash",
        "maturity_date":"2025-02-25",
        "overdue_payment":0.0,
        "account_status":"PARTIALLY ADVANCED",
        "repayment_schedule":23,
        "due_date":"23 of every month",
        "company_name":"UNITED TRACTORS",
        "group_company":"ASTRA - UNITED TRACTORS",
        "credit_utilization_percent":0.0
    },
    {
        "cif_key":6434415954,
        "id_number":229634225,
        "product_name":"Import LC_Product added for UAT",
        "credit_limit":1752000.0,
        "outstanding":0.0,
        "loan_type":"Non Cash",
        "maturity_date":"2019-01-19",
        "overdue_payment":0.0,
        "account_status":"PARTIALLY ADVANCED",
        "repayment_schedule":20,
        "due_date":"20 of every month",
        "company_name":"UNITED TRACTORS",
        "group_company":"ASTRA - UNITED TRACTORS",
        "credit_utilization_percent":0.0
    },
    {
        "cif_key":6434415954,
        "id_number":140144982,
        "product_name":"Import LC_Product added for UAT",
        "credit_limit":351557.1084,
        "outstanding":0.0,
        "loan_type":"Non Cash",
        "maturity_date":"2010-09-01",
        "overdue_payment":0.0,
        "account_status":"PARTIALLY ADVANCED",
        "repayment_schedule":23,
        "due_date":"23 of every month",
        "company_name":"UNITED TRACTORS",
        "group_company":"ASTRA - UNITED TRACTORS",
        "credit_utilization_percent":0.0
    },
    {
        "cif_key":6434415954,
        "id_number":202644604,
        "product_name":"Import LC_Product added for UAT",
        "credit_limit":730000000.0,
        "outstanding":0.0,
        "loan_type":"Non Cash",
        "maturity_date":"2014-02-11",
        "overdue_payment":0.0,
        "account_status":"PARTIALLY ADVANCED",
        "repayment_schedule":20,
        "due_date":"20 of every month",
        "company_name":"UNITED TRACTORS",
        "group_company":"ASTRA - UNITED TRACTORS",
        "credit_utilization_percent":0.0
    },
    {
        "cif_key":6434415954,
        "id_number":346593753,
        "product_name":"Import LC_Product added for UAT",
        "credit_limit":855965.88,
        "outstanding":0.0,
        "loan_type":"Non Cash",
        "maturity_date":"2017-12-31",
        "overdue_payment":0.0,
        "account_status":"PARTIALLY ADVANCED",
        "repayment_schedule":20,
        "due_date":"20 of every month",
        "company_name":"UNITED TRACTORS",
        "group_company":"ASTRA - UNITED TRACTORS",
        "credit_utilization_percent":0.0
    },
    {
        "cif_key":6434415954,
        "id_number":310698990,
        "product_name":"Import LC_Product added for UAT",
        "credit_limit":65611514123.0999984741,
        "outstanding":0.0,
        "loan_type":"Non Cash",
        "maturity_date":"2025-05-01",
        "overdue_payment":0.0,
        "account_status":"PARTIALLY ADVANCED",
        "repayment_schedule":20,
        "due_date":"20 of every month",
        "company_name":"UNITED TRACTORS",
        "group_company":"ASTRA - UNITED TRACTORS",
        "credit_utilization_percent":0.0
    },
    {
        "cif_key":6434415954,
        "id_number":1363663708,
        "product_name":"Productive Credit - KMK Bank KORPORASI USD",
        "credit_limit":9358974.3585999999,
        "outstanding":150632692301.6669921875,
        "loan_type":"Cash",
        "maturity_date":"2025-03-11",
        "overdue_payment":0.0,
        "account_status":"PARTIALLY ADVANCED",
        "repayment_schedule":19,
        "due_date":"19 of every month",
        "company_name":"UNITED TRACTORS",
        "group_company":"ASTRA - UNITED TRACTORS",
        "credit_utilization_percent":1609500.0
    },
    {
        "cif_key":6434415954,
        "id_number":247352238,
        "product_name":"Import LC_Product added for UAT",
        "credit_limit":0.0,
        "outstanding":0.0,
        "loan_type":"Non Cash",
        "maturity_date":"2015-08-31",
        "overdue_payment":0.0,
        "account_status":"ACCEPTED",
        "repayment_schedule":20,
        "due_date":"20 of every month",
        "company_name":"UNITED TRACTORS",
        "group_company":"ASTRA - UNITED TRACTORS",
        "credit_utilization_percent":null
    },
    {
        "cif_key":6434415954,
        "id_number":255341844,
        "product_name":"Import LC_Product added for UAT",
        "credit_limit":36500000.0,
        "outstanding":0.0,
        "loan_type":"Non Cash",
        "maturity_date":"2025-12-17",
        "overdue_payment":0.0,
        "account_status":"PARTIALLY ADVANCED",
        "repayment_schedule":20,
        "due_date":"20 of every month",
        "company_name":"UNITED TRACTORS",
        "group_company":"ASTRA - UNITED TRACTORS",
        "credit_utilization_percent":0.0
    },
    {
        "cif_key":6434415954,
        "id_number":311303457,
        "product_name":"Import LC_Product added for UAT",
        "credit_limit":65700000000.0,
        "outstanding":5529447205576.1396484375,
        "loan_type":"Non Cash",
        "maturity_date":"2025-05-11",
        "overdue_payment":0.0,
        "account_status":"PARTIALLY ADVANCED",
        "repayment_schedule":20,
        "due_date":"20 of every month",
        "company_name":"UNITED TRACTORS",
        "group_company":"ASTRA - UNITED TRACTORS",
        "credit_utilization_percent":8416.2057923533
    },
    {
        "cif_key":6434415954,
        "id_number":1360518345,
        "product_name":"Productive Credit - KMK Bank KORPORASI USD",
        "credit_limit":9358974.3585999999,
        "outstanding":0.0,
        "loan_type":"Cash",
        "maturity_date":"2025-02-15",
        "overdue_payment":0.0,
        "account_status":"APPROVED IN PRINC",
        "repayment_schedule":26,
        "due_date":"26 of every month",
        "company_name":"UNITED TRACTORS",
        "group_company":"ASTRA - UNITED TRACTORS",
        "credit_utilization_percent":0.0
    },
    {
        "cif_key":6434415954,
        "id_number":229639972,
        "product_name":"Import LC_Product added for UAT",
        "credit_limit":1752000.0,
        "outstanding":0.0,
        "loan_type":"Non Cash",
        "maturity_date":"2026-01-19",
        "overdue_payment":0.0,
        "account_status":"PARTIALLY ADVANCED",
        "repayment_schedule":20,
        "due_date":"20 of every month",
        "company_name":"UNITED TRACTORS",
        "group_company":"ASTRA - UNITED TRACTORS",
        "credit_utilization_percent":0.0
    },
    {
        "cif_key":6434415954,
        "id_number":155024216,
        "product_name":"Import LC_Product added for UAT",
        "credit_limit":102200000.0,
        "outstanding":0.0,
        "loan_type":"Non Cash",
        "maturity_date":"2025-05-14",
        "overdue_payment":0.0,
        "account_status":"PARTIALLY ADVANCED",
        "repayment_schedule":23,
        "due_date":"23 of every month",
        "company_name":"UNITED TRACTORS",
        "group_company":"ASTRA - UNITED TRACTORS",
        "credit_utilization_percent":0.0
    },
    {
        "cif_key":6434415954,
        "id_number":150981002,
        "product_name":"Import LC_Product added for UAT",
        "credit_limit":8760000.0,
        "outstanding":0.0,
        "loan_type":"Non Cash",
        "maturity_date":"2014-02-27",
        "overdue_payment":0.0,
        "account_status":"PARTIALLY ADVANCED",
        "repayment_schedule":20,
        "due_date":"20 of every month",
        "company_name":"UNITED TRACTORS",
        "group_company":"ASTRA - UNITED TRACTORS",
        "credit_utilization_percent":0.0
    },
    {
        "cif_key":6434415954,
        "id_number":255341998,
        "product_name":"Import LC_Product added for UAT",
        "credit_limit":219000000.0,
        "outstanding":0.0,
        "loan_type":"Non Cash",
        "maturity_date":"2025-12-17",
        "overdue_payment":0.0,
        "account_status":"PARTIALLY ADVANCED",
        "repayment_schedule":20,
        "due_date":"20 of every month",
        "company_name":"UNITED TRACTORS",
        "group_company":"ASTRA - UNITED TRACTORS",
        "credit_utilization_percent":0.0
    },
    {
        "cif_key":6434415954,
        "id_number":140144667,
        "product_name":"Import LC_Product added for UAT",
        "credit_limit":351557.1084,
        "outstanding":0.0,
        "loan_type":"Non Cash",
        "maturity_date":"2016-09-30",
        "overdue_payment":0.0,
        "account_status":"PARTIALLY ADVANCED",
        "repayment_schedule":20,
        "due_date":"20 of every month",
        "company_name":"UNITED TRACTORS",
        "group_company":"ASTRA - UNITED TRACTORS",
        "credit_utilization_percent":0.0
    },
    {
        "cif_key":6434415954,
        "id_number":1363979648,
        "product_name":"Productive Credit - KMK Bank KORPORASI USD",
        "credit_limit":9358974.3585999999,
        "outstanding":150632692301.6669921875,
        "loan_type":"Cash",
        "maturity_date":"2025-03-11",
        "overdue_payment":0.0,
        "account_status":"PARTIALLY ADVANCED",
        "repayment_schedule":19,
        "due_date":"19 of every month",
        "company_name":"UNITED TRACTORS",
        "group_company":"ASTRA - UNITED TRACTORS",
        "credit_utilization_percent":1609500.0
    },
    {
        "cif_key":6434415954,
        "id_number":212277613,
        "product_name":"Import LC_Product added for UAT",
        "credit_limit":784725618.0,
        "outstanding":0.0,
        "loan_type":"Non Cash",
        "maturity_date":"2025-06-27",
        "overdue_payment":0.0,
        "account_status":"PARTIALLY ADVANCED",
        "repayment_schedule":20,
        "due_date":"20 of every month",
        "company_name":"UNITED TRACTORS",
        "group_company":"ASTRA - UNITED TRACTORS",
        "credit_utilization_percent":0.0
    },
    {
        "cif_key":6434415954,
        "id_number":310950568,
        "product_name":"Import LC_Product added for UAT",
        "credit_limit":507122388168.0999755859,
        "outstanding":0.0,
        "loan_type":"Non Cash",
        "maturity_date":"2025-05-05",
        "overdue_payment":0.0,
        "account_status":"PARTIALLY ADVANCED",
        "repayment_schedule":20,
        "due_date":"20 of every month",
        "company_name":"UNITED TRACTORS",
        "group_company":"ASTRA - UNITED TRACTORS",
        "credit_utilization_percent":0.0
    },
    {
        "cif_key":6434415954,
        "id_number":202645132,
        "product_name":"Import LC_Product added for UAT",
        "credit_limit":730000000.0,
        "outstanding":0.0,
        "loan_type":"Non Cash",
        "maturity_date":"2014-02-11",
        "overdue_payment":0.0,
        "account_status":"PARTIALLY ADVANCED",
        "repayment_schedule":20,
        "due_date":"20 of every month",
        "company_name":"UNITED TRACTORS",
        "group_company":"ASTRA - UNITED TRACTORS",
        "credit_utilization_percent":0.0
    },
    {
        "cif_key":6434415954,
        "id_number":310699305,
        "product_name":"Import LC_Product added for UAT",
        "credit_limit":65611514123.0999984741,
        "outstanding":52552308.7199999988,
        "loan_type":"Non Cash",
        "maturity_date":"2025-05-01",
        "overdue_payment":0.0,
        "account_status":"PARTIALLY ADVANCED",
        "repayment_schedule":20,
        "due_date":"20 of every month",
        "company_name":"UNITED TRACTORS",
        "group_company":"ASTRA - UNITED TRACTORS",
        "credit_utilization_percent":0.0800961682
    },
    {
        "cif_key":6457123552,
        "id_number":874763414,
        "product_name":"Import LC_Product added for UAT",
        "credit_limit":2920000000.0,
        "outstanding":0.0,
        "loan_type":"Non Cash",
        "maturity_date":"2026-07-19",
        "overdue_payment":0.0,
        "account_status":"PARTIALLY ADVANCED",
        "repayment_schedule":20,
        "due_date":"20 of every month",
        "company_name":"SEMEN INDONESIA",
        "group_company":"SEMEN INDONESIA GROUP",
        "credit_utilization_percent":0.0
    },
    {
        "cif_key":6457123552,
        "id_number":999880343,
        "product_name":"Import LC_Product added for UAT",
        "credit_limit":438000000000.0,
        "outstanding":218340507457.3399963379,
        "loan_type":"Non Cash",
        "maturity_date":"2025-06-01",
        "overdue_payment":0.0,
        "account_status":"PARTIALLY ADVANCED",
        "repayment_schedule":20,
        "due_date":"20 of every month",
        "company_name":"SEMEN INDONESIA",
        "group_company":"SEMEN INDONESIA GROUP",
        "credit_utilization_percent":49.8494309263
    },
    {
        "cif_key":6457123552,
        "id_number":1006987383,
        "product_name":"Import LC_Product added for UAT",
        "credit_limit":14600000000.0,
        "outstanding":0.0,
        "loan_type":"Non Cash",
        "maturity_date":"2026-07-25",
        "overdue_payment":0.0,
        "account_status":"PARTIALLY ADVANCED",
        "repayment_schedule":20,
        "due_date":"20 of every month",
        "company_name":"SEMEN INDONESIA",
        "group_company":"SEMEN INDONESIA GROUP",
        "credit_utilization_percent":0.0
    },
    {
        "cif_key":6457123552,
        "id_number":1126863523,
        "product_name":"Productive Credit - TL Bank KORPORASI IDR",
        "credit_limit":3369665478074.9599609375,
        "outstanding":2720091410012.8798828125,
        "loan_type":"Cash",
        "maturity_date":"2028-02-03",
        "overdue_payment":162393517015.5199890137,
        "account_status":"PARTIALLY ADVANCED",
        "repayment_schedule":18,
        "due_date":"18 of every month",
        "company_name":"SEMEN INDONESIA",
        "group_company":"SEMEN INDONESIA GROUP",
        "credit_utilization_percent":80.7228915663
    },
    {
        "cif_key":6457123552,
        "id_number":1006989262,
        "product_name":"Import LC_Product added for UAT",
        "credit_limit":14600000000.0,
        "outstanding":0.0,
        "loan_type":"Non Cash",
        "maturity_date":"2026-07-25",
        "overdue_payment":0.0,
        "account_status":"PARTIALLY ADVANCED",
        "repayment_schedule":20,
        "due_date":"20 of every month",
        "company_name":"SEMEN INDONESIA",
        "group_company":"SEMEN INDONESIA GROUP",
        "credit_utilization_percent":0.0
    },
    {
        "cif_key":6457123552,
        "id_number":801052795,
        "product_name":"Import LC_Product added for UAT",
        "credit_limit":42792600000.0,
        "outstanding":225485312743.799987793,
        "loan_type":"Non Cash",
        "maturity_date":"2025-06-01",
        "overdue_payment":0.0,
        "account_status":"PARTIALLY ADVANCED",
        "repayment_schedule":20,
        "due_date":"20 of every month",
        "company_name":"SEMEN INDONESIA",
        "group_company":"SEMEN INDONESIA GROUP",
        "credit_utilization_percent":526.9259468782
    },
    {
        "cif_key":6457123552,
        "id_number":874807370,
        "product_name":"Import LC_Product added for UAT",
        "credit_limit":2920000000.0,
        "outstanding":0.0,
        "loan_type":"Non Cash",
        "maturity_date":"2026-07-19",
        "overdue_payment":0.0,
        "account_status":"PARTIALLY ADVANCED",
        "repayment_schedule":20,
        "due_date":"20 of every month",
        "company_name":"SEMEN INDONESIA",
        "group_company":"SEMEN INDONESIA GROUP",
        "credit_utilization_percent":0.0
    },
    {
        "cif_key":7266342610,
        "id_number":1287915730,
        "product_name":"Productive Credit - TL Bank KORPORASI IDR",
        "credit_limit":270100000000.0,
        "outstanding":270100000000.0,
        "loan_type":"Cash",
        "maturity_date":"2028-12-08",
        "overdue_payment":5402000000.0,
        "account_status":"PARTIALLY ADVANCED",
        "repayment_schedule":20,
        "due_date":"20 of every month",
        "company_name":"GARUDAFOOD PUTRA PUTRI JAYA TBK",
        "group_company":"GARUDAFOOD",
        "credit_utilization_percent":100.0
    },
    {
        "cif_key":7266342610,
        "id_number":1335270719,
        "product_name":"Productive Credit - TL Bank KORPORASI IDR",
        "credit_limit":109500000000.0,
        "outstanding":0.0,
        "loan_type":"Cash",
        "maturity_date":"2030-09-05",
        "overdue_payment":0.0,
        "account_status":"PENDING DISCHARGED",
        "repayment_schedule":20,
        "due_date":"20 of every month",
        "company_name":"GARUDAFOOD PUTRA PUTRI JAYA TBK",
        "group_company":"GARUDAFOOD",
        "credit_utilization_percent":0.0
    },
    {
        "cif_key":7266342610,
        "id_number":1084841365,
        "product_name":"Productive Credit - TL Bank KORPORASI IDR",
        "credit_limit":365000000000.0,
        "outstanding":343100000000.0,
        "loan_type":"Cash",
        "maturity_date":"2027-12-13",
        "overdue_payment":10721875000.0,
        "account_status":"PARTIALLY ADVANCED",
        "repayment_schedule":20,
        "due_date":"20 of every month",
        "company_name":"GARUDAFOOD PUTRA PUTRI JAYA TBK",
        "group_company":"GARUDAFOOD",
        "credit_utilization_percent":94.0
    },
    {
        "cif_key":7266342610,
        "id_number":942226188,
        "product_name":"Productive Credit - KI Bank KORPORASI IDR",
        "credit_limit":1460000000000.0,
        "outstanding":273750000000.0,
        "loan_type":"Cash",
        "maturity_date":"2027-01-06",
        "overdue_payment":76650000000.0,
        "account_status":"PARTIALLY ADVANCED",
        "repayment_schedule":20,
        "due_date":"20 of every month",
        "company_name":"GARUDAFOOD PUTRA PUTRI JAYA TBK",
        "group_company":"GARUDAFOOD",
        "credit_utilization_percent":18.75
    },
    {
        "cif_key":7266342610,
        "id_number":1333792517,
        "product_name":"Productive Credit - KI Bank KORPORASI IDR",
        "credit_limit":401500000000.0,
        "outstanding":391462500000.0,
        "loan_type":"Cash",
        "maturity_date":"2029-09-05",
        "overdue_payment":10037500000.0,
        "account_status":"PARTIALLY ADVANCED",
        "repayment_schedule":20,
        "due_date":"20 of every month",
        "company_name":"GARUDAFOOD PUTRA PUTRI JAYA TBK",
        "group_company":"GARUDAFOOD",
        "credit_utilization_percent":97.5
    },
    {
        "cif_key":6458751302,
        "id_number":816929235,
        "product_name":"Import LC_Product added for UAT",
        "credit_limit":718137.3394000001,
        "outstanding":0.0,
        "loan_type":"Non Cash",
        "maturity_date":"2026-01-17",
        "overdue_payment":0.0,
        "account_status":"PARTIALLY ADVANCED",
        "repayment_schedule":20,
        "due_date":"20 of every month",
        "company_name":"SEMEN INDONESIA",
        "group_company":"SEMEN INDONESIA GROUP",
        "credit_utilization_percent":0.0
    },
    {
        "cif_key":6458751302,
        "id_number":690769018,
        "product_name":"Import LC_Product added for UAT",
        "credit_limit":590333.8596,
        "outstanding":0.0,
        "loan_type":"Non Cash",
        "maturity_date":"2025-07-23",
        "overdue_payment":0.0,
        "account_status":"PARTIALLY ADVANCED",
        "repayment_schedule":20,
        "due_date":"20 of every month",
        "company_name":"SEMEN INDONESIA",
        "group_company":"SEMEN INDONESIA GROUP",
        "credit_utilization_percent":0.0
    }
]
